import { Route, Routes } from 'react-router-dom';

import { IProtectedRouteItem } from '@websential/cosmic-v20';
import { NoFoundPage } from '../../pages/Anonymous/NoFoundPage';
import React from 'react';
import { RoleRouteGuard } from '../../common/Common';

export type IProtectedRoutes = {
  routeList: IProtectedRouteItem[];
  menuList: any[];
  isAdminUser: number;
};

export const ProtectedRoleRoutes: React.FC<IProtectedRoutes> = ({
  routeList,
  menuList,
  isAdminUser,
}) => (
  <Routes>
    {routeList.map(({ component: Component, path }) => (
      <Route
        key={path}
        path={`/${path}`}
        element={
          <RoleRouteGuard
            menuList={menuList}
            isAdminUser={isAdminUser}
          >
            <Component />
          </RoleRouteGuard>
        }
      />
    ))}

    {/* 👇 local fallback (SAFE) */}
    <Route path="*" element={<NoFoundPage />} />
  </Routes>
);